export default __webpack_public_path__ + "static/media/deliland-momi-icon.c2dda96d.png";